"use client"

import { Button } from "@/components/ui/button"
import { ChevronLeft, ChevronRight } from "@/lib/icons"
import { useTranslations } from "next-intl"

// Extracted from components/booru-detail-modal.tsx (pure move: same JSX, same behaviour).
interface AlbumSideButtonsProps {
  currentAlbumPage: number
  handleAlbumNextPage: () => void
  handleAlbumPrevPage: () => void
  hideUI: boolean
  isAlbum: boolean
  totalAlbumPages: number
  viewingAdSlot: number | null
}

export function AlbumSideButtons({
  currentAlbumPage,
  handleAlbumNextPage,
  handleAlbumPrevPage,
  hideUI,
  isAlbum,
  totalAlbumPages,
  viewingAdSlot,
}: AlbumSideButtonsProps) {
  const tt = useTranslations("booruDetailModal")
  return (
    <>
      {!hideUI && isAlbum && (
                <>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="absolute left-[3px] top-1/2 -translate-y-1/2 h-16 w-6 rounded-sm bg-black/50 hover:bg-black/70 text-white z-10 disabled:opacity-30 disabled:cursor-not-allowed pointer-events-auto transition-all"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleAlbumPrevPage()
                    }}
                    disabled={viewingAdSlot === null && currentAlbumPage === 0}
                    title={tt("previousPage")}
                  >
                    <ChevronLeft className="h-6 w-6" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="absolute right-[3px] top-1/2 -translate-y-1/2 h-16 w-6 rounded-sm bg-black/50 hover:bg-black/70 text-white z-10 disabled:opacity-30 disabled:cursor-not-allowed pointer-events-auto transition-all"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleAlbumNextPage()
                    }}
                    disabled={viewingAdSlot === null && currentAlbumPage === totalAlbumPages - 1}
                    title={tt("nextPage")}
                  >
                    <ChevronRight className="h-6 w-6" />
                  </Button>
                </>
              )}
    </>
  )
}
